module.exports = __webpack_public_path__ + "img/marine_app_4.6df93433.jpg";